import { useContext } from 'react';
import { TealiumContext } from '../providers/TealiumProvider';
const useTealium = () => {
    return useContext(TealiumContext);
};
export default useTealium;
